module.exports = __webpack_public_path__ + "img/app_messenger_text.1900757c.png";